import React from 'react';
import { Info as InfoIcon } from 'lucide-react';
import Tooltip from 'src/componentes/tooltip';

type InfoProps = {
  /** Texto da ajuda. */
  text?: React.ReactNode;
  /** Função que devolve o texto. Tem prioridade sobre `text`. */
  renderContent?: () => React.ReactNode;
  /** Lado do ícone em que a ajuda abre. */
  placement?: 'top' | 'right' | 'bottom' | 'left';
  /** Largura máxima da ajuda (padrão 200px). */
  tooltipMaxWidth?: number | string;
  /** Alinhamento do texto da ajuda. */
  tooltipTextAlign?: 'left' | 'center' | 'right' | 'justify';
  /** Tamanho do ícone, em px. */
  size?: number;
  /** Id do ícone. */
  id?: string;
  className?: string;
  style?: React.CSSProperties;
};

/**
 * Ícone "i" de ajuda: mostra o texto ao passar o mouse, focar ou clicar, e continua aberto depois do clique.
 * @import import Info from 'src/componentes/info';
 */
const Info = ({
  id,
  placement,
  text,
  className,
  style,
  renderContent,
  tooltipMaxWidth,
  tooltipTextAlign,
  size = 16,
}: InfoProps) => (
  <span style={style} className={className}>
    <Tooltip
      text={renderContent ? renderContent() : text}
      placement={placement}
      maxWidth={tooltipMaxWidth}
      textAlign={tooltipTextAlign}
      keepOpenOnClick
    >
      <span
        id={id}
        tabIndex={0}
        className="tw:inline-flex tw:rounded-full tw:align-middle tw:leading-0 tw:text-[#ccc] tw:outline-none tw:focus-visible:ring-[3px] tw:focus-visible:ring-ring/50"
      >
        <InfoIcon size={size} strokeWidth={1.75} />
      </span>
    </Tooltip>
  </span>
);

export default Info;
